import api from './api';

import { ALERTAS_ROUTE } from '../constants/apiRoutes';

export default {
	exportToCsv(filtro) {
		return api.post(ALERTAS_ROUTE.ALERTA_CSV, filtro, { responseType: 'blob' });
	},
};
